import React from "react";
import { useState } from "react";
import { BsWechat } from "react-icons/bs";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import First_Answer from "./First_Answer";
import Second_Answer from "./Second_Answer";
import Third_Answer from "./Third_Answer";
import Frth_Answer from "./Frth_Answer";
import Sixth_Answer from "./Sixth_Answer";
import Fivth_Answer from "./Fivth_Answer";
import Seventh_Answer from "./Seventh_Answer";
import Eigth_Answer from "./Eigth_Answer";
import Ninth_Answer from "./Ninth_Answer";
import Tenth_Answer from "./Tenth_Answer";


const Questions = () => {

 const [show,  setShow]  =   useState(false);
 const [show1, setShow1] = useState(false);
 const [show2, setShow2] = useState(false);
 const [show3, setShow3] = useState(false);
 const [show4, setShow4] = useState(false);
 const [show5, setShow5] = useState(false);
 const [show6, setShow6] = useState(false);
 const [show7, setShow7] = useState(false);
 const [show8, setShow8] = useState(false);
 const [show9, setShow9] = useState(false);
 

  return (
    <>
      <div className="faq_container">
        <div className="faq_content">
          <div className="customer_service">
            <div className="customer_icon">
              <BsWechat color="#FFC74B" size={50} />
            </div>
            <div className="customer_content">
              <h2>Customer Services</h2>
              <p>+91-9821020995</p>
              <p id="callnow">
                <u>CALL NOW</u>
              </p>
            </div>
          </div>

          <div className="question_container">
            <h2>Popular Questions</h2>
            <div className="question_section">
              <button className="question_btn"
              onClick={()=>setShow((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>What is INTERNATIONAL EDUCATION AWARDS</p>
              </button>

             {
               show === true ? <First_Answer/> : ""
             }

              <button className="question_btn"
              onClick={()=>setShow1((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>Who Can Apply for this Awards?</p>
              </button>
            
               {
                 show1 === true ? <Second_Answer/> : ""
               }

             <button className="question_btn"
              onClick={()=>setShow2((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>Can i know the names of other winners?</p>
              </button>
            
               {
                 show2 === true ? <Third_Answer/> : ""
               }

              <button className="question_btn"
              onClick={()=>setShow3((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>When would the result be announnced?</p>
              </button>
            
               {
                 show3 === true ? <Frth_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow4((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>What are the document required?</p>
              </button>
            
               {
                 show4 === true ? <Fivth_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow5((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>What is the judging criteria?</p>
              </button>
            
               {
                 show5 === true ? <Sixth_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow6((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>How is this platform going to help us?</p>
              </button>
            
               {
                 show6 === true ? <Seventh_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow7((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>Am i eligible to register for the award,even though i can't attend the award caremony?</p>
              </button>
            
               {
                 show7 === true ? <Eigth_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow8((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>Are there any charges for nomination?</p>
              </button>
            
               {
                 show8 === true ? <Ninth_Answer/>: ""
               }

              <button className="question_btn"
              onClick={()=>setShow9((prevState)=>!prevState)}
              >
                <MdOutlineKeyboardArrowDown size={30} />
                <p>How Do i File Nomination?</p>
              </button>
            
               {
                 show9 === true ? <Tenth_Answer/>: ""
               }

            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Questions;
